import ProfileApi from "../../../api/ProfileApi";

import RefreshModel from "./RefreshModel";

class RefreshLicenses extends RefreshModel {
  profile;

  profileApi;

  constructor(profile, profileUrl) {
    super();

    this.profile = profile;

    this.profileApi = new ProfileApi(profileUrl);
  }

  refresh = () => {
    this.setLoading(true);

    this.profileApi
      .refreshLicense()
      .then(({ data }) => {
        if (!data) {
          this.setError({ reason: "no_data_error_custom" });
        } else {
          this.clearErrors();
        }

        this.profile.setUser({ ...this.profile.user, ...data });

        this.setLoading(false);
      })
      .catch((error) => {
        this.setError(error.data);

        this.setLoading(false);
      });
  };
}

export default RefreshLicenses;
